export function generateSearchPagePath(keyword: string) {
  const encodeKeyword = encodeURIComponent(keyword);
  return `/search?q=${encodeKeyword}&text=${encodeKeyword}`;
}
